export const VehicleVariables = {
    numberOfVehicles: '40,000'
}
